// initial state
import * as types from "../mutation-types";
import subscriptionService from "../../api/subscription-service";

const state = {
  modified: false,
  puzzleHistories: []
}


// getters
const getters = {
  getPuzzleHistories: (state) => {
    return state.puzzleHistories;
  },
  getModfiedPuzzleHistory: (state) => {
    return state.modified;
  }
}

const actions = {
  setPuzzleHistories(store, puzzleHistories) {
    store.commit(types.SET_PUZZLE_HISTORIES, puzzleHistories);
  },
  updatePuzzleHistory(store, puzzleHistory) {
    store.commit(types.MODIFY_PUZZLE_HISTORY)
  },
  updatePuzzleReview(store, puzzleHistory){
    store.commit(types.MODIFY_PUZZLE_HISTORY)
    subscriptionService.updatePuzzleHistoryReview(puzzleHistory, data => {
      store.commit(types.UPDATE_PUZZLE_HISTORY, data.puzzleHistories[Object.keys(data.puzzleHistories)[0]]);
      store.commit(types.SUCCESS, "Your Review Was Submitted!");
    })
  }
}

// mutations
const mutations = {
  [types.SET_PUZZLE_HISTORIES] (state, puzzleHistories ) {
    state.puzzleHistories = puzzleHistories
  },
  [types.MODIFY_PUZZLE_HISTORY] (state ) {
    state.modified = true
  },
  [types.UPDATE_PUZZLE_HISTORY] (state, puzzleHistory ) {
    Object.keys(state.puzzleHistories).forEach(key => {
      if (puzzleHistory.id == key){
        state.puzzleHistories[key] = puzzleHistory
        state.modified = false
      }
    });

  },
}

export default {
  state,
  getters,
  actions,
  mutations
}